import { Component, OnInit, OnDestroy } from '@angular/core';
import { JobImpressaoService } from '../../services/job-impressao.service';

import { ServidorImpressaoExecutorService } from '../../services/servidor-impressao-executor.service';
import {ImpressaoService} from "../../services/impressao.service";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import { SocketService } from '../../services/socket.service';

@Component({
  selector: 'app-gerenciador-jobs-impressao',
  templateUrl: './gerenciador-jobs-impressao.component.html',
  styleUrls: ['./gerenciador-jobs-impressao.component.scss']
})
export class GerenciadorJobsImpressaoComponent implements OnInit, OnDestroy {
  jobs: any[] = [];
  jobsHistorico: any[] = [];
  servidoresAtivos: any[] = [];
  carregando = true;
  carregandoHistorico = false;
  erro: string;
  mensagemSucesso: string;

  // Controle de abas
  abaAtiva = 'pendentes'; // 'pendentes' ou 'historico'

  // Controle de expansão/retração por job
  private expandedJobs: { [jobId: number]: boolean } = {};
  private expandedJobsHistorico: { [jobId: number]: boolean } = {};

  // Filtros
  filtroStatus: string;
  filtroServidor: string ;
  filtroImpressora: string ;

  // Paginação do histórico
  paginaAtual = 1;
  totalPaginas = 0;
  itensPorPagina = 5;
  // Status disponíveis
  statusDisponiveis = [
    { valor: '', label: 'Todos os Status' },
    { valor: 'PENDENTE', label: 'Pendente' },
    { valor: 'NA_FILA', label: 'Na Fila' },
    { valor: 'PROCESSANDO', label: 'Processando' },
    { valor: 'IMPRIMINDO', label: 'Imprimindo' },
    { valor: 'CONCLUIDO', label: 'Concluído' },
    { valor: 'ERRO', label: 'Erro' },
    { valor: 'CANCELADO', label: 'Cancelado' }
  ];

  // Propriedades para controle do servidor
  servidorImpressao: any;
  servidorAtivo = false;
  servidorConfigurado: any;
  podeConfigurar = false;
  empresa: any;
  impressorasConfiguradas: Array<any> = []
  impressorasQzTray: Array<any> = []
  constructor(
    private jobImpressaoService: JobImpressaoService,
    private impressao: ImpressaoService,  private constantsService: ConstantsService,
    public servidorExecutor: ServidorImpressaoExecutorService,
    private socketService: SocketService
  ) {
    this.constantsService.empresa$.subscribe( (empresa: any) => {
      if(!empresa) return;
      this.empresa = empresa;
      this.setImpressorasConfiguradas();
    })
  }

  setImpressorasConfiguradas(){
    if(this.empresa && this.servidorImpressao){
      if(this.empresa.configImpressao.impressoras)
        this.impressorasConfiguradas = this.empresa.configImpressao.impressoras.filter(
        (item: any) => item.servidorImpressao && item.servidorImpressao.id === this.servidorImpressao.id)

      // Verificar status das impressoras no QZ Tray
       this.verificarStatusImpressoras();
    }
  }

  verificarStatusImpressoras() {
    // Obter lista de impressoras do QZ Tray
    this.impressorasQzTray =   this.impressao.impressoras || [];
    // Atualizar status de cada impressora configurada
    this.impressorasConfiguradas.forEach(impressora => {
      impressora.disponivelQzTray = this.impressorasQzTray.some(
        impQz => impQz === impressora.nome
      );
    });

    return ""
  }

  disponivelQzTray(impressora: any){
    let impressorasQzTray =   this.impressao.impressoras || [];

   return  impressorasQzTray.some(
     impQz => impQz === impressora.nome
   );
  }

  async ngOnInit(): Promise<void> {
    // Verificar se este computador é um servidor configurado
    this.servidorImpressao = await this.servidorExecutor.getServidorRegistrado();
    this.setJobs();
    this.setImpressorasConfiguradas();

    // Iniciar verificação de timeout para jobs imprimindo
    this.iniciarVerificacaoTimeout();
  }

  recarregueJobs(){
    this.carregando = true;
    this.servidorExecutor.carregueJobs().then( () => {
        this.setJobs();
    })
  }

  setJobs(){
    this.jobs = this.servidorExecutor.jobs;
    this.carregando = false;
  }

  ngOnDestroy(): void { }

  // Expansão/retração
  estaExpandido(job: any): boolean {
    return !!this.expandedJobs[job.id];
  }

  estaExpandidoHistorico(job: any): boolean {
    return !!this.expandedJobsHistorico[job.id];
  }

  toogleJob(job: any): void {
    this.expandedJobs[job.id] = !this.expandedJobs[job.id];
  }

  toogleJobHistorico(job: any): void {
    this.expandedJobsHistorico[job.id] = !this.expandedJobsHistorico[job.id];
  }

  // Utilitário: é servidor ativo nesta máquina?
  eServidorLocal(): boolean {
    return !!this.servidorImpressao;
  }

  // QZ Tray
  get qzConectado(): boolean {
    return !!this.impressao.qzInstalado;
  }

  conectouQzTray(){
    // Quando QZ Tray conectar, verificar status das impressoras
    this.verificarStatusImpressoras();
  }

  obterPosicaoFila(job: any): number {
    if (job.status !== 'PENDENTE' && job.status !== 'NA_FILA') {
      return 0; // Não está na fila
    }

    const jobsNaFila = this.jobs.filter(j =>
      j.status === 'PENDENTE' || j.status === 'NA_FILA'
    );

    // Ordenar por prioridade e data
    const jobsOrdenados = [...jobsNaFila].sort((a, b) => {
      if (a.prioridade !== b.prioridade) {
        return a.prioridade - b.prioridade;
      }
      return new Date(a.criadoEm).getTime() - new Date(b.criadoEm).getTime();
    });

    return jobsOrdenados.findIndex(j => j.id === job.id) + 1;
  }

  obterTempoEstimado(job: any): string {
    if (job.status !== 'PENDENTE' && job.status !== 'NA_FILA') {
      return '';
    }

    const posicao = this.obterPosicaoFila(job);
    const tempoPorJob = 30; // 30 segundos por job (estimativa)
    const tempoTotal = posicao * tempoPorJob;

    if (tempoTotal < 60) {
      return `${tempoTotal}s`;
    } else {
      const minutos = Math.floor(tempoTotal / 60);
      const segundos = tempoTotal % 60;
      return `${minutos}m ${segundos}s`;
    }
  }

  async cancelarJob(job: any): Promise<void> {
    try {
      job.cancelando = true;
      await this.jobImpressaoService.atualizeStatus(job.id, 'CANCELADO');
      this.mensagemSucesso = 'Job cancelado com sucesso!';
      job.cancelando = false;
    } catch (erro) {
      job.cancelando = false;
      console.error('Erro ao cancelar job:', erro);
      this.erro = 'Erro ao cancelar job';
    }
  }

  async reexecutarJob(job: any): Promise<void> {
    try {
      // Só pode reexecutar jobs com erro
      if (job.status !== 'ERRO') {
        this.erro = 'Só é possível reexecutar jobs com erro';
        return;
      }

      await this.servidorExecutor.processarJob(job)
      this.mensagemSucesso = 'Job reexecutado com sucesso!';
    } catch (erro) {
      console.error('Erro ao reexecutar job:', erro);
      this.erro = 'Erro ao reexecutar job';
    }
  }

  obtenhaStatusClass(status: string): string {
    switch (status) {
      case 'PENDENTE': return 'status-pendente';
      case 'NA_FILA': return 'status-na-fila';
      case 'PROCESSANDO': return 'status-processando';
      case 'IMPRIMINDO': return 'status-imprimindo';
      case 'CONCLUIDO': return 'status-concluido';
      case 'ERRO': return 'status-erro';
      case 'CANCELADO': return 'status-cancelado';
      default: return 'status-default';
    }
  }

  obtenhaStatusIcon(status: string): string {
    switch (status) {
      case 'PENDENTE': return '⏳';
      case 'NA_FILA': return '';
      case 'PROCESSANDO': return '⚙️';
      case 'IMPRIMINDO': return '️';
      case 'CONCLUIDO': return '✅';
      case 'ERRO': return '❌';
      case 'CANCELADO': return '🚫';
      default: return '❓';
    }
  }

  obtenhaStatusLabel(status: string): string {
    switch (status) {
      case 'PENDENTE': return 'Pendente';
      case 'NA_FILA': return 'Na Fila';
      case 'PROCESSANDO': return 'Processando';
      case 'IMPRIMINDO': return 'Imprimindo';
      case 'CONCLUIDO': return 'Concluído';
      case 'ERRO': return 'Erro';
      case 'CANCELADO': return 'Cancelado';
      default: return status;
    }
  }

  apliqueFiltros(): void {
    if(this.abaHitoricoAtiva()){
      this.carregarHistorico();
    } else {
      //filtrar direto na tela
      this.jobs.forEach((job) => {
        job.ocultar = false;
        if(this.filtroImpressora){
          job.ocultar = job.impressora.id !== this.filtroImpressora
        }

        if(this.filtroStatus && !job.ocultar){
          job.ocultar = job.status !== this.filtroStatus
        }
      })
    }
  }

  temFiltro(){
    return  this.filtroStatus || this.filtroImpressora || this.filtroStatus
  }

  limpeFiltros(): void {
    this.filtroStatus = '';
    this.filtroServidor = '';
    this.filtroImpressora = '';
    this.apliqueFiltros();
  }

  limparMensagens(): void {
    this.erro = '';
    this.mensagemSucesso = '';
  }

  // Controle de abas
  alterarAba(aba: string): void {
    this.abaAtiva = aba;
    if (aba === 'historico') {
      this.carregarHistorico();
    }
  }

  abaPendentesAtiva(){
    return this.abaAtiva === 'pendentes'
  }
  abaHitoricoAtiva(){
    return this.abaAtiva === 'historico'
  }

  // Carregar histórico de jobs concluídos
  async carregarHistorico(): Promise<void> {
    if (this.carregandoHistorico) return;

    this.carregandoHistorico = true;
    let filtro: any = {};

    if(this.filtroImpressora)
        filtro.impressora = this.filtroImpressora

    if(this.filtroStatus)
      filtro.status = this.filtroStatus

    try {
      // Buscar jobs concluídos com paginação
      const jobs = await this.jobImpressaoService.listeJobsHistorico(
        this.servidorImpressao.id,
        this.paginaAtual,
        this.itensPorPagina,
        filtro
      );

      if (jobs) {
        this.jobsHistorico = jobs;
        this.totalPaginas = jobs.length < this.itensPorPagina ?  this. paginaAtual  :
           this. paginaAtual   + 1;
      }
    } catch (erro) {
      console.error('Erro ao carregar histórico:', erro);
      this.erro = 'Erro ao carregar histórico de jobs';
    } finally {
      this.carregandoHistorico = false;
    }
  }

  // Paginação do histórico
  irParaPagina(pagina: number): void {
    if (pagina >= 1 && pagina <= this.totalPaginas) {
      this.paginaAtual = pagina;
      this.carregarHistorico();
    }
  }

  // Reimpressão de job do histórico
  async reimprimirJob(job: any): Promise<void> {
    try {
      await this.servidorExecutor.processarJob(job, true);
      this.mensagemSucesso = 'Job enviado para reimpressão!';
    } catch (erro) {
      console.error('Erro ao reimprimir job:', erro);
      this.erro = 'Erro ao reimprimir job';
    }
  }

  // Verificação de timeout para jobs imprimindo
  private iniciarVerificacaoTimeout(): void {
    setInterval(() => {
      this.verificarTimeoutJobs();
    }, 30000); // Verifica a cada 30 segundos
  }

  private verificarTimeoutJobs(): void {
    const agora = new Date();
    const timeout = 90 * 1000; // 90 segundos

    this.jobs.forEach(job => {
      if (job.status === 'IMPRIMINDO' && job.processadoEm) {
        const tempoImprimindo = agora.getTime() - new Date(job.processadoEm).getTime();

        if (tempoImprimindo > timeout) {
          // Marcar como erro por timeout
          this.jobImpressaoService.atualizeStatus(job.id, 'ERRO', 'Timeout: Job imprimindo há mais de 90 segundos')
            .then(() => {
              this.recarregueJobs();
            })
            .catch(erro => {
              console.error('Erro ao marcar job como timeout:', erro);
            });
        }
      }
    });
  }

  // Verificar se job está imprimindo há muito tempo
  jobComTimeout(job: any): boolean {
    if (job.status !== 'IMPRIMINDO' || !job.processadoEm) {
      return false;
    }

    const agora = new Date();
    const tempoImprimindo = agora.getTime() - new Date(job.processadoEm).getTime();
    return tempoImprimindo > 60 * 1000; // Mais de 60 segundos (warning)
  }

  // Método para verificar se é master tab
  isMasterTab(): boolean {
    return this.socketService.isMaster();
  }

  servidorMaster(){
    return this.servidorImpressao && this.isMasterTab()
  }
}
